<template>
  <label for="file-upload">
    <a-input-search
        :value="file ? file.name : ''"
        :placeholder="$t('fileUpload.placeholders.selectFile')"
        :enter-button="$t('fileUpload.upload')"
        size="default"
        @click="onFileClick"
        :class="['fileInput', { success: file }]"
        @search="upload"
    >
    </a-input-search>
    <input type="file" id="file-upload" hidden @change="onFileChange"/>
  </label>
</template>

<script>
export default {
  name: "FileUpload",
  data: () => ({
    file: null
  }),
  methods: {
    onFileClick() {
      const input = document.getElementById('file-upload');
      input.click()
    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    upload() {
      this.$emit('upload', this.file);
    }
  }
}
</script>

<style scoped>
.fileInput {
  margin-bottom: -7px;
  border: 1px solid #d30101;
  border-radius: 4px;
}
.success {
  border-color: #07a207;
}
</style>
